import { useParams } from 'react-router-dom'
import { MemberDetailPage } from '@/components/members/member-detail-page'

export function AdminMemberDetail() {
  const { id } = useParams<{ id: string }>()
  if (!id) return null

  return (
    <MemberDetailPage
      memberId={id}
      listPath="/admin/members"
      canDelete
      canManageRole
      canManagePlots
      plotsBasePath="/admin/plots"
    />
  )
}
